import emailjs from '@emailjs/browser';
import { useState } from 'react';
import { BsArrowRight } from 'react-icons/bs';

import '../../styles/form-fields.styles.scss';
import './form-contact.styles.scss';

const initialForm = {
  fullName: '',
  email: '',
  message: ''
};

const FormContact = () => {
  const [isTouchedFields, setIsTouchedFields] = useState({});
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [formContent, setFormContent] = useState(initialForm);

  const { fullName, email, message } = formContent;

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormContent((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (e) => {
    const name = e.target.name;
    setIsTouchedFields((prev) => ({ ...prev, [name]: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    let isEmptyField = false;

    for (const field in formContent) {
      if (formContent[field] === '') {
        setIsTouchedFields((prev) => ({ ...prev, [field]: true }));
        isEmptyField = true;
      }
    }

    if (isEmptyField) {
      return;
    }

    const templateParams = {
      from_name: email,
      to_name: 'lacanacbd@gmail.com',
      name: fullName,
      message_html: message
    };

    try {
      await emailjs.send(
        'service_iulcrpi',
        'template_w2bdetp',
        templateParams,
        'wBuHaQ5vpkys2OrGo'
      );
      setIsTouchedFields({});
      setFormContent(initialForm);
      setSuccessMsg('Votre message a été envoyé avec succès');
    } catch {
      setErrorMsg("une erreur s'est produite lors de l'envoi");
    }
  };

  return (
    <form className="contact-form brand-form" onSubmit={handleSubmit}>
      <div className="contact-form-row">
        <label className="form-field">
          <span className="form-field-label">Nom complet *</span>
          <input
            value={fullName}
            name="fullName"
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <span className="form-field-error">
            {!fullName &&
              isTouchedFields.fullName &&
              'Saisir votre nom et prénom'}
          </span>
        </label>

        <label className="form-field">
          <span className="form-field-label">Email *</span>
          <input
            value={email}
            type="email"
            name="email"
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <span className="form-field-error">
            {!email &&
              isTouchedFields.email &&
              'Entrez une adresse e-mail valide'}
          </span>
        </label>
      </div>

      <label className="form-field">
        <span className="form-field-label">Message *</span>
        <textarea
          value={message}
          name="message"
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <span className="form-field-error">
          {!message && isTouchedFields.message && 'Saisir votre demande'}
        </span>
      </label>

      <p className="contact-form-required">* champs requis</p>

      <div className="contact-form-footer">
        <button className="brand-link contact-form-submit" type="submit">
          Envoyer
          <span className="brand-link-arrow" aria-hidden="true">
            <BsArrowRight />
          </span>
        </button>

        {successMsg && (
          <p className="contact-form-feedback is-success">{successMsg}</p>
        )}
        {errorMsg && (
          <p className="contact-form-feedback is-error">{errorMsg}</p>
        )}
      </div>
    </form>
  );
};
export default FormContact;
